import { render, staticRenderFns } from "./OptionsComponent.vue?vue&type=template&id=adcc1c22&scoped=true"
import script from "./OptionsComponent.vue?vue&type=script&lang=js"
export * from "./OptionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcc1c22",
  null
  
)

export default component.exports